import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=f98014f6"
import script from "./Bottombar.vue?vue&type=script&lang=js"
export * from "./Bottombar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports